import React, { useEffect, useRef, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './CustomDatePciker.css';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import { deformatDateUTC, formatDateUTC } from '../../apis/Utils';

export const DateRangeFilter = ({
  inputRef,
  handleIconClick,
  styleProp,
  selected,
  onChange,
  placeholderText,
  markingDone = false,
  setOpenDeliverDialog,
  minDate,
  MaxDate,
  disabled
}) => {
  // Handle date change with UTC formatting
  const handleDateChange = date => {
    const finalDate = formatDateUTC(date);
    console.log(finalDate, date, 'date format'); // Logs the UTC formatted date
    onChange({ date: date, displayDate: finalDate }); // Pass the original date to parent
  };

  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
    .custom-calendar {
      background-color: #f0f8ff !important;
      border-radius: 10px !important;
      font-size: 13px;
      padding: 1px;
    }
    .custom-popper {
      z-index: 1050 !important;
    }
    .custome_date_picker .custome {
      position: absolute;
      right: 8px;
      top: 50%;
      transform: translateY(-50%);
      color: #333;
      cursor: pointer;
      z-index: 1;
      pointer-events: auto;
      font-size: 18px !important;
    }
    .custome_date_picker .custome:hover {
      color: #1976d2;
    }
    .shipments_date_picker .deliver_custome {
      position: absolute;
      right: 40%;
      top: 77px;
      transform: translateY(-50%);
      color: #333;
      cursor: pointer;
      z-index: 1;
      pointer-events: auto;
    }
    .shipments_date_picker .deliver_custome:hover {
      color: #1976d2;
    }
  `;
    document.head.appendChild(style);
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const datepickerRef = useRef(null);

  return (
    <div
      className={
        styleProp === 'shipmentsTable'
          ? 'shipments_date_picker'
          : 'custome_date_picker'
      }
    >
      <DatePicker
        disabled={disabled}
        minDate={minDate}
        maxDate={MaxDate}
        ref={inputRef}
        selected={selected}
        onChange={handleDateChange}
        dateFormat='MMM d, yyyy'
        placeholderText={placeholderText}
        calendarClassName='custom-calendar'
        popperClassName='custom-popper'
        className='custom-input'
        wrapperClassName='date-picker-full-width'
        popperPlacement='bottom-start'
        onCalendarOpen={() => {
          if (markingDone) {
            setOpenDeliverDialog(true);
          }
        }}
        onCalendarClose={() => {
          if (markingDone) {
            setOpenDeliverDialog(false);
          }
        }}
      />
      <CalendarMonthIcon
        className={
          styleProp === 'shipmentsTable' ? 'deliver_custome' : 'custome'
        }
        onClick={handleIconClick}
      />
    </div>
  );
};
